import axiosApi from "../axiosInstance";

const getCompanyList = async () => {
    try {
        const response = await axiosApi.post(`Company/GetAllCompany`);
        return response?.data;
    } catch (error) {
        console.log("Error getCompanyList===>:", error);
    }
};
const getCompanyBankDetails = async (body) => {
    try {
        const response = await axiosApi.post(`Company/GetCompanyBankDetails`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getCompanyBankDetails===>:", error);
    }
};


const addCompany = async (body) => {
    //debugger
    try {
        const response = await axiosApi.post(`Company/CreateCompany`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addCompany===>", error);
    }
};

export const CompanyService = {
    getCompanyList,
    addCompany,
    getCompanyBankDetails,
}